export const DELETE_TAG_SUCCESS = 'DELETE_TAG_SUCCESS';

export const deleteTagSuccess = ( id: string ) => ({
    type: DELETE_TAG_SUCCESS,
    payload: {
        id,
    },
});
